import { Icons } from '@/assets/icons/icons';
import { YStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { ICON_CLASS, TEXT_STYLE } from '../tokens';

import type { ReactNode } from 'react';

// The quiet line a screenshot shows in its own frame once it cannot be shown
export const QuietFrame = ({
  className,
  aspectRatio,
  children,
}: {
  className: string;
  aspectRatio: number;
  children: ReactNode;
}) => (
  <YStack
    center
    className={cn(
      className,
      'gap-[calc(6*var(--ac-u))] p-[calc(10*var(--ac-u))] text-center'
    )}
    style={{ aspectRatio }}
  >
    <Icons.imageOff className={cn(ICON_CLASS, 'text-foreground-subtle')} />
    <span className={cn(TEXT_STYLE.meta, 'text-foreground-muted')}>
      {children}
    </span>
  </YStack>
);
